import initialState from './initialState';
import actionType from './actionTypes';

const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.SHOW_INFO: {
            const { message, icon, id } = action.payload;
            return {
                message,
                icon,
                level: 'info',
                id,
            };
        }
        case actionType.SHOW_ERROR: {
            const { message, icon, id } = action.payload;
            return {
                message,
                icon,
                level: 'error',
                id,
            };
        }

        case actionType.SHOW_SUCCESS: {
            const { message, icon, id } = action.payload;
            return {
                message,
                icon,
                level: 'success',
                id,
            };
        }

        case actionType.SHOW_WARNING: {
            const { message, icon, id } = action.payload;
            return {
                message,
                icon,
                level: 'warning',
                id,
            };
        }

        default:
            return state;
    }
};

export default notificationReducer;
